// extracted by mini-css-extract-plugin
export var underlinedLink = "_pd-0";